import { GeckoInspectionType } from 'types'

export const METHOD_TO_PROCEDURE: Partial<Record<GeckoInspectionType, string>> =
  {
    rug: 'GR-TOKA-001-PRC Rev.1',
  }

export const METHOD_TO_PROCEDURE_TITLE: Partial<
  Record<GeckoInspectionType, string>
> = {
  rug: 'General Rapid Ultrasonic Gridding Using TOKA Robots',
}
